import { Suspense } from "react";
import Navigation from "./../components/Navigation";
import styled from "styled-components";
import { Main, Header, Img, Rubrik1 } from "../styles/AboutStyles";
import SEO from "./../components/SEO";

import flygbild from "./../images/flygbild2.jpg";
import rubrik1 from "./../images/rubrik_visit.png";
import HomeButton from "../components/HomeButton";
import { useContent } from "../i18n/useContent";

const Iframe = styled.iframe`
    width: 100%;
    height: 400px;
    border: 1px solid black;
    margin-bottom: 1rem;
`;

const Visit = () => {
    const Content = useContent('visit');

    return (
        <>
            <SEO pageKey="visit" />
            <Navigation page={'visit'} />
            <Main>
                <article>
                    <Header><h1 alt={"Kom till Oxelö Krog!"}><Rubrik1 src={rubrik1} width='100%' style={{margin: '0 auto', maxWidth: '700px'}}  /></h1> </Header>
                    <div>
                        <Img src={flygbild} />
                        <Suspense fallback={<div>...</div>}>
                            <Content />
                        </Suspense>

                        <Iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1037.5163649980389!2d17.1278253!3d58.6622473!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4658cc82e7136377%3A0x9e50a2dd2271f318!2sOxel%C3%B6%20Krog!5e0!3m2!1ssv!2sse!4v1646396010134!5m2!1ssv!2sse"></Iframe>

                        <HomeButton />
                    </div>

                </article>
            </Main>
        </>
    );
}

export default Visit;
